import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    width: ", ";\n    height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import React, { forwardRef } from 'react';
import { SpinnerIcon } from '../icons';
var StyledLoader = styled(SpinnerIcon)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.unit * 3, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.unit * 3, "px");
});
export var Loader = forwardRef(function (props, ref) {
  return React.createElement(StyledLoader, Object.assign({}, props, {
    ref: ref,
    viewBox: '0 0 100 100'
  }));
});
Loader.displayName = 'Loader';